/**
 * 简体中文 — Simplified Chinese, mainland wording.
 * Any key missing here falls back to English (locales/en.js).
 */
export default {
    language: {
        label:  '语言',
        switch: '更改语言',
        names:  { 'en': '英语', 'zh-TW': '繁体中文', 'zh-CN': '简体中文', 'ja': '日语' },
    },

    suggest: {
        title:   '本网站提供简体中文版',
        body:    '要切换为简体中文吗？您之后随时可以再更改语言。',
        accept:  '切换为简体中文',
        decline: '继续使用英文',
    },

    common: {
        loading:        '加载中...',
        error:          '错误',
        no_data:        '暂无数据。',
        day_n:          '第 {n} 天',
        try_again:      '重试',
        close:          '关闭',
        skip:           '跳过',
        next:           '下一步 >',
        end:            '结束',
        download:       '下载',
        submit:         '提交',
        add:            '添加',
        download_error: '处理文件时出现问题，请重试或联系客服。',
    },

    page: {
        home:      '首页',
        login:     '登录',
        chat:      '聊天',
        quotation: '报价单',
        invoices:  '文档',
        contact:   '联系我们',
        help:      '帮助',
        faq:       '常见问题',
        access:    '访问权限管理',
        notfound:  '404 页面',
    },

    nav: {
        groups:    '团组',
        chat:      '聊天',
        documents: '文档',
        support:   '支持',
        help:      '帮助',
        faq:       '常见问题',
    },

    breadcrumb: {
        quotations: '报价单列表',
        fit:        'FIT',
        help:       '帮助',
        faq:        '常见问题',
    },

    header: {
        available:     '在线',
        manage_access: '管理访问权限',
        logout:        '退出登录',
    },

    notif: {
        count: '{n} 条新通知',
        empty: '暂无通知',
    },

    login: {
        title:        '登录',
        username:     '用户名',
        password:     '密码',
        button:       '登录',
        loading:      '加载中...',
        err_username: '请输入用户名',
        err_password: '请输入密码',
        err_auth:     '登录失败，请检查用户名和密码。',
        by:           'FiveDragons Agency 提供',
    },

    home: {
        loading: '加载中...',
        error:   '错误！',
    },

    table: {
        invoice:  '发票编号',
        id:       'ID',
        your_ref: '您的参考编号',
        date:     '日期',
        contact:  '联系人',
        status:   '状态',
        action:   '操作',
        invalid:  '收到的数据无效。',
    },

    status: {
        archived: '已归档',
        go_ahead: '已确认',
        ongoing:  '进行中',
    },

    quotation: {
        title:         '报价单 {ref}',
        loading:       '正在加载报价单...',
        error:         '下载数据时出错。',
        last_update:   '最新更新',
        loading_short: '（加载中...）',
        show_chat:     '显示聊天',
        hide_chat:     '隐藏聊天',
        operating_on:  '当前操作',
        ref:           '编号',
        your_ref:      '您的编号',
        tabs: {
            map:         '地图',
            itinerary:   '行程',
            hotels:      '酒店',
            restaurants: '餐厅',
            monuments:   '景点',
            rates:       '价格',
            files:       '文件',
        },
        tour: {
            step1: '详细信息都在这些选项卡中...',
            step2: '您可以在这里与您的专员实时交流。',
            step3: '您也可以隐藏聊天窗口，以获得更多空间。',
        },
    },

    badge: {
        waiting_list:    '候补',
        no_availability: '无空位',
        confirmed:       '已确认',
        canceled:        '已取消',
        on_request:      '待确认',
    },

    hotels: {
        day:    '天数',
        hotel:  '酒店',
        city:   '城市',
        status: '状态',
    },

    deadlines: {
        deadline:         '取消期限',
        tab:              '取消期限',
        title:            '取消期限（可免费取消至此日期）',
        intro:            '供应商保留预订至取消期限为止；超过期限后，预订即为确定，无法取消且必须付款。',
        summary_critical: '{n} 个取消期限在 3 周内',
        summary_warning:  '{n} 个在 2 个月内',
        none_soon:        '未来 2 个月内没有取消期限。',
        passed:           '已过期',
        none:             '无取消期限',
        supplier:         '供应商',
        type:             '类型',
        city:             '城市',
        day:              '天数',
        date:             '取消期限',
        time_left:        '剩余时间',
        since:            '保留起始日',
        type_hotel:       '酒店',
        type_restaurant:  '餐厅',
        tooltip:          '可免费取消至 {date}',
        tooltip_since:    '（自 {date} 起保留）',
        legend_critical:  '3 周内',
        legend_warning:   '2 个月内',
        legend_moderate:  '6 个月内',
        legend_safe:      '6 个月以上',
        legend_passed:    '已过期',
    },

    map: {
        loading: '请稍候，地图加载中...',
        error:   '无法加载预览。',
        alt:     '地图',
        title:   '地图预览',
    },

    monuments: {
        name:     '名称',
        location: '位置',
        docs:     '资料',
    },

    rates: {
        unavailable:  '该报价单的价格尚未提供。',
        retry_prefix: '请稍后再试，或',
        contact_us:   '联系我们',
        retry_suffix: '。',
        pax:          '人数',
    },

    restaurants: {
        day:     '天数',
        name:    '名称',
        status:  '状态',
        menu_of: '{name} 的菜单 - 第 {day} 天',
    },

    chat: {
        loading:           '加载中...',
        talking_in_prefix: '您正在 ',
        talking_in_suffix: ' 中聊天',
        says_prefix:       '',
        says_suffix:       ' 说：',
        uploading:         '上传中...',
        bad_response:      '服务器响应异常。',
        placeholder:       '在此输入消息...',
        try_again:         '重试',
        active:            '在线',
        connecting:        '连接中...',
        done:              '完成',
        error_prefix:      '错误：',
        home:              '首页',
        quotation_prefix:  '报价单/',
    },

    files: {
        error:         '错误。',
        loading:       '加载中...',
        empty:         '未找到任何文件。',
        folder:        '文件夹',
        files:         '文件',
        folders:       '文件夹',
        last_accessed: '上次访问：',
        count:         '{n} 个文件',
        group:         '团组 {n}',
        details:       '详细信息',
        activity:      '活动记录',
        download:      '下载',
        info:          '信息',
        type:          '类型',
        size:          '大小',
        location:      '位置',
        created:       '创建时间',
        creation:      '创建',
    },

    access: {
        agents:    '专员',
        none:      '您目前没有任何专员，请使用下方表单添加。',
        add_title: '添加专员',
        fullname:  '姓名',
        username:  '用户名',
        password:  '密码',
        add:       '添加',
    },

    help: {
        title:               '帮助',
        subject:             '主题：',
        subject_placeholder: '请输入主题',
        message:             '消息',
        message_placeholder: '请输入您的消息',
        submit:              '提交',
    },

    contact: {
        redirecting: '请稍候，正在跳转...',
    },

    notfound: {
        title: '404 - 页面未找到',
        body:  '抱歉，找不到您请求的页面。',
    },
};
